import angular from 'angular';
import datatable from './datatable/datatable';
import directives from './directives/directives';
import editor from './editor/editor';
import formsEinzelticketcode from './forms/einzelticketcode/einzelticketcode';
import formsPresseticketcode from './forms/presseticketcode/presseticketcode';
import formsEinzelticket from './forms/einzelticket/einzelticket';
import formsEmittenten from './forms/emittenten/emittenten';
import formsInvestoren from './forms/investoren/investoren';
import formsNbu from './forms/nbu/nbu';
import navigation from './navigation/navigation';
import privacyDeclaration from './privacyDeclaration/privacyDeclaration';
import saveDialog from './saveDialog/saveDialog';
import cookiesModal from './cookiesModal/cookiesModal';
import scheduler from './scheduler/scheduler';

let commonModule = angular.module('app.common', [
  datatable,
  directives,
  editor,
  formsEinzelticketcode,
  formsPresseticketcode,
  formsEinzelticket,
  formsEmittenten,
  formsInvestoren,
  privacyDeclaration,
  formsNbu,
  navigation,
  saveDialog,
  scheduler,
  cookiesModal
])

.name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js